import { getSiteDomain } from 'utils/common';

const getWeatherUrl = (isPrimeUser = false) => {
  const PRIME_WEATHER_URL = `${getSiteDomain()}/toiignorevp/forecast_weathertoday_ext.cms`;
  const NON_PRIME_WEATHER_URL = `${getSiteDomain()}/forecast_weathertoday_ext.cms`;
  return isPrimeUser ? PRIME_WEATHER_URL : NON_PRIME_WEATHER_URL;
};

const iconsMap = {
  '0': 'tornado',
  '1': 'tropicalstrom',
  '2': 'hurricane',
  '1087': 'cloudyheavythundershower',
  '4': 'cloudyheavythundershower',
  '1279': 'raintosnowshowers',
  '1282': 'raintosnowshowers',
  '1069': 'rainsleet',
  '1264': 'wintrymixsnowsleet',
  '1072': 'freezingdrizzle',
  '1168': 'freezingdrizzle',
  '1171': 'freezingdrizzle',
  '1150': 'cloudylightrain', //for night: overcastlightrain
  '1153': 'cloudylightrain', //for night: overcastlightrain
  '1198': 'freezingrain',
  '1201': 'freezingrain',
  '1180': 'cloudylightrain',
  '1183': 'cloudylightrain', // for night: overcastlightrain
  '1186': 'cloudyrain', // for night: overcastrain
  '1189': 'cloudyrain', // for night: overcastrain
  '1213': 'cloudysnow', // for night: overcastsnow
  '14': 'cloudysnow', // for night : overcastsnow
  '1114': 'blowingdriftingsnow',
  '1258': 'blowingdriftingsnow',
  '1261': 'cloudysnow', // for night: overcastsnow
  '17': 'hail',
  '1204': 'sleet',
  '1207': 'sleet',
  '1246': 'sleet',
  '1252': 'sleet',
  '19': 'partlycloudyduststorm',
  '1135': 'foggy',
  '1147': 'foggy',
  '21': 'hazy',
  '22': 'hazy',
  '1117': 'breezy',
  '24': 'blowingspraywindy',
  '25': 'frigidicecrystals',
  '26': 'cloudy',
  '27': 'overcast', // for night: overcast
  '1006': 'cloudy', // for night: overcast
  '1030': 'cloudy',
  '1009': 'overcast', // night
  '1003': 'partlycloudy', // day
  '31': 'clearsky', // night
  '32': 'sunny', // day
  '33': 'clearsky',
  '34': 'clearsky',
  '1273': 'mixedrainhail',
  '1276': 'mixedrainhail',
  '1000': 'sunny',
  '1225': 'cloudymoderatethundershower', // day
  '1255': 'cloudymoderatethundershower', // day
  '38': 'partlycloudymoderatethundershower',
  '1063': 'overcastrain',
  '1192': 'overcastheavyrain',
  '1195': 'overcastheavyrain',
  '1222': 'partlycloudysnow',
  '1066': 'overcastsnow', //night
  '1210': 'overcastsnow', // night
  '44': 'NA',
  '1240': 'overcastrain',
  '1216': 'overcastsnow',
  '1219': 'overcastsnow',
  '1243': 'overcastmoderatethundershower',
  '1237': 'overcastmoderatethundershower',
};

export { iconsMap, getWeatherUrl };
